/**
 * WP-3 — `apply_discount` commerce action handler (currently UNSUPPORTED).
 *
 * The intended behavior is to apply a coupon to the active cart via the BFF
 * apply-coupon proxy (`ApplyCouponResponse` exists in
 * `@trafilea/tss-lib-carts-contracts` 0.6.0). That BFF proxy leg does NOT exist
 * yet (storefront-bff `/v1/storefront/carts` mounts get/create/update/packs
 * only — no apply-coupon route). Per WP-3, until the proxy lands:
 *   - `apply_discount` is intentionally NOT in the schema `ACTION_TYPES` enum,
 *     so it cannot be authored/validated (funnels-go rejects it, WP-5); and
 *   - this handler returns a typed `unsupported` result so that any artifact
 *     which somehow reaches the runtime fails loudly instead of silently.
 *
 * When the BFF apply-coupon proxy ships, replace the body with the real call
 * and add `apply_discount` to the schema enum + registry-enum validation.
 */

import type { ActionExecutionContext, ActionExecutionResult, ActionHandler } from './types';

export const applyDiscountHandler: ActionHandler = {
  type: 'apply_discount',
  execute(ctx: ActionExecutionContext): ActionExecutionResult {
    ctx.logger.warn('apply_discount unsupported: BFF apply-coupon proxy leg is not wired yet', {
      stepId: ctx.stepId,
      actionId: ctx.action.id,
    });
    return { unsupported: true };
  },
};
